import React from 'react';
import { Box, Typography } from '@mui/material';
import { C, AVATAR_PALETTE } from '../../theme/adminTokens';

// Only ranks 1-3 get a badge — ranks 4+ render as plain text (handled by the caller, not
// here). Decorating every row would read as "AI-generated"; the top-3 treatment is the
// deliberate exception, not an oversight.
// Colors reuse AVATAR_PALETTE (no new colors introduced): gold/amber for 1st,
// muted slate for 2nd (silver), burnt-orange/bronze for 3rd.
const BADGE_STYLE = {
  1: { fill: AVATAR_PALETTE[5] }, // #B45309 — gold/amber
  2: { fill: C.muted },            // slate — silver
  3: { fill: AVATAR_PALETTE[4] },  // #C2410C — bronze
};

const WIDTH = 22;
const HEIGHT = 26;

// A flat ribbon/banner-tag shape (rectangle with a V-notch cut into the bottom edge) —
// the requested "ribbon badge" look, but sized and styled to actually stay legible at
// table-row scale: flat fill, no gradients/glossy shadow/crown (those only work at the
// ~200px size of the reference image; at 22px they'd just be noise).
const RIBBON_PATH = `M0,0 L${WIDTH},0 L${WIDTH},${HEIGHT * 0.72} L${WIDTH / 2},${HEIGHT} L0,${HEIGHT * 0.72} Z`;

export default function RankBadge({ rank }) {
  const style = BADGE_STYLE[rank];
  if (!style) {
    // Ranks 4+: plain text, no badge — intentional restraint, see note above.
    return (
      <Typography component="span" fontSize={13.5} fontWeight={600} sx={{ color: '#1e293b' }}>
        {rank}
      </Typography>
    );
  }

  return (
    <Box role="img" aria-label={`Rank ${rank}`} sx={{ width: WIDTH, height: HEIGHT, flexShrink: 0 }}>
      <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`}>
        <path d={RIBBON_PATH} fill={style.fill} />
        <text
          x={WIDTH / 2}
          y={HEIGHT * 0.46}
          textAnchor="middle"
          dominantBaseline="central"
          fontSize="12"
          fontWeight="800"
          fill="#ffffff"
        >
          {rank}
        </text>
      </svg>
    </Box>
  );
}
